import { LIMITS } from './constants.js';
/**
 * Turns a business name into a tenant slug.
 *
 * Shared so the signup form can show the visitor the slug they are about to
 * get before they submit — the slug ends up in their embed tag, so it should
 * not be a surprise.
 *
 * The output always satisfies `tenantSlugSchema`, or is empty when the name
 * had nothing usable in it (e.g. all punctuation), which the caller must then
 * fall back from.
 */
export function slugify(name) {
    const slug = name
        .normalize('NFKD')
        // Strip combining marks so "Café" becomes "cafe" rather than losing the e.
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, LIMITS.tenantSlug);
    // A trailing hyphen can reappear after the slice.
    return slug.replace(/-+$/, '');
}
//# sourceMappingURL=slug.js.map